export function useForgivenReasons() {
	const forgivenReasons = [
		{
			label: 'Client cancelled permanently',
			confirmation_message: 'Are you sure? This means the client no longer requires a service from the Agency and will be removed from your roster. We will now contact the client to confirm.',
			requires_confirmation: true,
			show_to_cleaner: true,
		},
		{ label: 'Client Away', confirmation_message: '', requires_confirmation: false, show_to_cleaner: true },
		{ label: 'Client forgot to leave key', confirmation_message: '', requires_confirmation: false, show_to_cleaner: true },
		{ label: 'Cleaner Away', confirmation_message: '', requires_confirmation: false, show_to_cleaner: true },
		{ label: 'Cleaner Sick', confirmation_message: '', requires_confirmation: false, show_to_cleaner: true },
		{ label: 'Job on hold Corona Virus', confirmation_message: '', requires_confirmation: false, show_to_cleaner: false },
		{
			label: 'New Job - not yet started',
			confirmation_message: 'I confirm that the job has not been started yet and the client will not have a service this week.',
			requires_confirmation: true,
			show_to_cleaner: true,
		},
		{ label: 'Service not required this week', confirmation_message: '', requires_confirmation: false, show_to_cleaner: true },
		{ label: 'Public Holiday', confirmation_message: '', requires_confirmation: false, show_to_cleaner: true },
		{ label: 'Floods', confirmation_message: '', requires_confirmation: false, show_to_cleaner: false },
		{ label: 'Bad Debt', confirmation_message: '', requires_confirmation: false, show_to_cleaner: false },
		{ label: 'Client Sick', confirmation_message: '', requires_confirmation: false, show_to_cleaner: false },
		{ label: 'Fee Error', confirmation_message: '', requires_confirmation: false, show_to_cleaner: false },
		{ label: 'Staff - Zero Fee', confirmation_message: '', requires_confirmation: false, show_to_cleaner: false },
		{ label: 'Free Service', confirmation_message: '', requires_confirmation: false, show_to_cleaner: false },
		{ label: 'Cleaner No Show', confirmation_message: '', requires_confirmation: false, show_to_cleaner: false },
		{ label: 'No Cleaner Available', confirmation_message: '', requires_confirmation: false, show_to_cleaner: false },
	];

	return {
		forgivenReasons,
	};
}
